import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49642f50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-outline" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "启用边框：", -1))
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "边框样式：", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "边框颜色：", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "边框粗细：", -1))

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElementOutline } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from './ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  InputNumber,
  Popover,
  Select,
  Switch,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ElementOutline',
  props: {
  fixed: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const SelectOption = Select.Option



const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const outline = ref<PPTElementOutline>()
const hasOutline = ref(false)

watch(handleElement, () => {
  if (!handleElement.value) return
  outline.value = 'outline' in handleElement.value ? handleElement.value.outline : undefined
  hasOutline.value = !!outline.value
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateOutline = (outlineProps: Partial<PPTElementOutline>) => {
  if (!handleElement.value) return
  const props = { outline: { ...outline.value, ...outlineProps } }
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

const toggleOutline = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    const _outline: PPTElementOutline = { width: 2, color: '#000', style: 'solid' }
    slidesStore.updateElement({ id: handleElement.value.id, props: { outline: _outline } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'outline' })
  }
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.fixed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Switch), {
              checked: hasOutline.value,
              onChange: _cache[0] || (_cache[0] = checked => toggleOutline(checked as boolean))
            }, null, 8, ["checked"])
          ])
        ]))
      : _createCommentVNode("", true),
    (hasOutline.value && outline.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_unref(Select), {
              style: {"flex":"3"},
              value: outline.value.style,
              onChange: _cache[1] || (_cache[1] = value => updateOutline({ style: value as 'dashed' | 'solid' }))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectOption), { value: "solid" }, {
                  default: _withCtx(() => [
                    _createTextVNode("实线边框")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SelectOption), { value: "dashed" }, {
                  default: _withCtx(() => [
                    _createTextVNode("虚线边框")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: outline.value.color,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = value => updateOutline({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: outline.value.color || '#000',
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_unref(InputNumber), {
              value: outline.value.width,
              onChange: _cache[3] || (_cache[3] = value => updateOutline({ width: value as number })),
              style: {"flex":"3"}
            }, null, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})